import React, { useEffect } from 'react';
import * as yup from 'yup';
import { Grid } from '@mui/material';
import { IThreadFormValues } from 'models/cases';
import { useTranslations } from 'hooks/useTranslations';
import Button from 'components/atoms/Button';
import { Box } from '@mui/material';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';
import { countEditorCharacters } from 'components/organisms/HtmlSlate';
import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormWyswigEditor } from 'components/molecules/FormWyswigEditor';
import { Elabels } from '../../helpers';
import { FormInput } from 'components/molecules/FormInput';

export interface ICommentForm {
  submitForm: (data: any) => void;
  closeTreadForm: () => void;
  editFormValues?: IThreadFormValues;
}
const initialFormValues: IThreadFormValues = { topic: '' };

export const ThreadForm = ({ submitForm, closeTreadForm, editFormValues }: ICommentForm) => {
  const { t } = useTranslations();

  const schema = yup.object({
    topic: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(250, t('general.field.validation.maxCharacters').replace('{0}', '250'))
      .trim(),
  });

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm<IThreadFormValues>({
    defaultValues: initialFormValues,
    resolver: yupResolver(schema) as unknown as Resolver<IThreadFormValues>,
  });

  useEffect(() => {
    reset(editFormValues);
  }, [editFormValues]);

  return (
    <Grid sx={{ p: 1 }}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <FormInput
              name="topic"
              label={t(Elabels.topic)}
              setValue={setValue}
              control={control}
              errors={errors}
              charsLimit={255}
              required
              id="thread_form_topic-input"
            />
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', xl: 'row' },
              gap: '12px',
              mt: '20px',
              width: '100%',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Button
                fullWidth
                label={t('general.cancel.button')}
                variant={EButtonVariants.outlined}
                onClick={() => {
                  reset(initialFormValues);
                  closeTreadForm();
                }}
                size={EButtonSizes.small}
                id="thread_form_cancel-button"
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Button
                variant={EButtonVariants.contained}
                label={t('general.save.button')}
                type="submit"
                fullWidth
                size={EButtonSizes.small}
                id="thread_form_save-button"
              />
            </Box>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};
